<template>
  <div class="login-form-home sign-up-form text-left" >
    <div class="login-form-wrapper">
      <div class="bp-logo">
        <img src="@/assets/images/logos/BP.png" alt="logo">
        <p class="app-name">{{ $t('OUTER_PAGES.common.player')}}</p>
      </div>

      <div class="text-align-left error no-margin" v-if="!linkIsValid & pageLoaded">
        {{ $t('OUTER_PAGES.emailChange.notValid') }}
      </div>

      <div class="text-align-left error no-margin" v-if="otherError">
        {{ $t('OUTER_PAGES.common.otherErorr') }}
      </div>

      <div class="text-align-left" v-if="linkIsValid & pageLoaded">
        {{ $t('OUTER_PAGES.emailChange.success')}}
      </div>

      <div class="text-align-left margin-top-10">
        <router-link :to="'/profile'" class="link" v-if="user">
          <i class="fas fa-chevron-left" aria-hidden="true"></i>
          {{ $t('OUTER_PAGES.common.goBack')}}
        </router-link>
        <router-link :to="'/login'" class="link" v-if="!user">
          <i class="fas fa-chevron-left" aria-hidden="true"></i>
          {{ $t('OUTER_PAGES.common.goBack')}}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/common/api.service'
import { EMAIL_CHANGE_CONFIRMATION_URL } from '@/constants/ApiConstants'
import { EMAIL_CHANGE_CONFIRMATION } from '@/store/action.types'
import { mapActions, mapGetters } from 'vuex'
import STATUS_CODES from '@/common/statusCodes'
import { TOASTER_SUCCESS } from '@/common/events.types'

export default {
  name: 'EmailChange',
  data () {
    return {
      pageLoaded: false,
      linkIsValid: false,
      otherError : false
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    confirmationToken: {
      get () {
        return this.$route.params.token
      }
    }
  },
  methods: {
    ...mapActions({
      emailChangedConfirmationAction: EMAIL_CHANGE_CONFIRMATION
    })
  },
  mounted () {
    ApiService.get(`${EMAIL_CHANGE_CONFIRMATION_URL.replace(':token', this.confirmationToken)}`)
      .then(response => {
        this.pageLoaded = true
        this.linkIsValid = true
        this.$eventHub.$emit(TOASTER_SUCCESS, {
          message: this.$t('OUTER_PAGES.emailChange.toastMessage')
        })

        setTimeout(() => {
          this.user ? this.$router.push('/profile') : this.$router.push('/login')
        }, 2000)
      })
      .catch(({ status }) => {
        if (status.code === STATUS_CODES.BP_404) {
          this.pageLoaded = true
          this.linkIsValid = false
        } else if (status.code === STATUS_CODES.BP_403) {
          this.pageLoaded = true
          this.linkIsValid = false
        } else {
          this.otherError = true
        }
      })
  },
}
</script>
